const menuBtn = document.getElementById('js-menuBtn');
const drawer  = document.getElementById('js-drawer');
const body    = document.body;

if (menuBtn && drawer) {
  menuBtn.addEventListener('click', function () {
    const isOpen = body.classList.toggle('menu-open');
    menuBtn.classList.toggle('is-active', isOpen);
    drawer.classList.toggle('is-open', isOpen);
    menuBtn.setAttribute('aria-expanded', String(isOpen));
    drawer.setAttribute('aria-hidden', String(!isOpen));
  });

  // ドロワー内リンクをクリックしたら閉じる
  drawer.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      body.classList.remove('menu-open');
      menuBtn.classList.remove('is-active');
      drawer.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
    });
  });
}
